import { observable, action, computed } from "mobx"
import request from "app/vendor/request"
import config from "app/config"

export default class {
  @observable apps = []
  @observable selectedRecycle = "data"
  @observable tableData = []
  @observable totalCount = 0
  @observable currentPageIndex = 1
  @observable queryMap = {
    belong: null,
    app: null,
    start: null,
    end: null,
    offset: 0,
    limit: 10,
    keywords:null,
    deleted: true,
  }

  @action getApps = () => {
    request.get(`${config.backend}/azf/apps?filter=used`)
    .checkToken()
    .commonDispose()
    .then((res) => {
      this.apps = res
    })
  }

  @action getTableData = () => {
    if (this.selectedRecycle === "data") {
      return request.get(`${config.backend}/azf/datas?${this.queryString}`)
      .checkToken()
      .dataListDispose()
    } else {
      return request.get(`${config.backend}/azf/groups/reports?${this.queryString}`)
      .checkToken()
      .dataListDispose()
    }
  }

  @computed get queryString () {
    let queryCount = 0
    let queryString = ""
    for (var key in this.queryMap) {
      if (queryCount === 0 && queryString[key] !== undefined) {
        queryString = `${key}=${this.queryMap[key]}`
      } else {
        if (this.queryMap[key]!==null) {
          queryString += `&${key}=${this.queryMap[key]}`
        } else {
          queryString += ""
        }
      }
    }
    return queryString
  }

  @action updateTableData = (data) => {
    this.totalCount = data.totalCount
    this.tableData = data.dataList
  }

  @action updateDataListData = (data) => {
    this.totalCount = data.totalCount
    this.tableData = data.dataList
  }

  @action initOffset = () => {
    this.queryMap.offset = 0
  }

  @action updateQueryMap = (data) => {
    this.queryMap = {...this.queryMap, ...data}
  }

  @action initPageIndex = () => {
    this.currentPageIndex = 1
  }

  @action getDetailData = (reportId) => {
    return request.get(`${config.backend}/azf/reports/${reportId}`)
    .checkToken()
    .commonDispose()
  }

  @action downloadPdf = (groupId, templateId) => {
    return request.post(`${config.backend}/azf/reports/preview/${groupId}/group/download?templateId=${templateId}`)
    .checkToken()
    .commonDispose()
  }

  @action downloadStep2 = (downloadId) => {
    return request.get(`${config.backend}/azf/reports/pdf/${downloadId}/status`)
    .checkToken()
    .commonDispose()
  }

  @action shareGroup = (groupId, username) => {
    return request.put(`${config.backend}/azf/groups/${groupId}/share/${username}`)
    .checkToken()
    .commonDispose()
  }

  @action dataSwitch = (reportId) => {
    return request.get(`${config.backend}/azf/reports/${reportId}`)
    .checkToken()
    .commonDispose()
  }

  @action deleteReport = (groupId, reportId) => {
    return request.delete(`${config.backend}/azf/groups/${groupId}/reports/${reportId}`)
    .checkToken()
    .commonDispose()
  }

  @action recoveryReport = (groupId, reportId) => {
    return request.put(`${config.backend}/azf/groups/${groupId}/reports/${reportId}/recovery`)
    .checkToken()
    .commonDispose()
  }

  @action getReportHistory = (groupId) => {
    return request.get(`${config.backend}/azf/groups/${groupId}/history`)
    .checkToken()
    .commonDispose()
  }

  @action getDataHistory = (dataId) => {
    return request.get(`${config.backend}/azf/datas/${dataId}/history`)
    .checkToken()
    .commonDispose()
  }

  /*
   * @query: 获取数据的类型
   */

  @action updateGroup = (groupId, groupName) => {
    return request.put(`${config.backend}/azf/groups/${groupId}/reports`)
    .send({groupName})
    .checkToken()
    .commonDispose()
  }

  @action getSearchData = (appId, keyword) => {
    return request.get(`${config.backend}/azf/reports/apps/${appId}?keywords=${keyword}`)
    .checkToken()
    .commonDispose()
  }

  @action clearState = () => {
    this.tableData = []
    this.totalCount = 0
    this.currentPageIndex = 1
    this.queryMap = {
      belong: null,
      app: null,
      start: null,
      end: null,
      offset: 0,
      limit: 10,
      keywords:null,
      deleted: true
    }
  }

  @action createNewGroup = (newGroupData) => {
    return request.post(`${config.backend}/azf/groups/reports`)
    .send(newGroupData)
    .checkToken()
    .commonDispose()
  }

  @action setSelectedRecycle = (type) => {
    this.selectedRecycle = type
  }

  @action recoveryData = (id) => {
    return request.put(`${config.backend}/azf/datas/${id}/recovery`)
    .checkToken()
    .commonDispose()
  }

  @action recoveryGroup = (id) => {
    return request.put(`${config.backend}/azf/groups/${id}/reports/recovery`)
    .checkToken()
    .commonDispose()
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/azf/recycle.js